import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import DescriptionPageTemplate from './DescriptionPageTemplate';
import { findPageData } from '../../../util/HelperFunctions';
import AuthContext from '../../../store/auth-context';
import useValidatePageAccess from '../../../hooks/useValidatePageAccess';
import { getFilteredPageDataList, getPageDataRawFiltered, getShouldValidateAccess } from '../../../util/filteredPageData';
import LoadingPage from '../../../components/UI/Loading';
import { PageDataContext } from '../../../App';

/**
 * Open API 문서 상세 페이지 컴포넌트
 */
const DetailLoadingPage = () => {
  const pageDataList = useContext(PageDataContext);
  const authCtx = useContext(AuthContext);
  const newParams = useParams();
  const [params, setParams] = useState(newParams);
  const navigate = useNavigate();

  // 현재 URL params를 사용하여 pageData 찾기
  const currentPath = params['*'] || newParams['*'];
  const pageDataRaw = findPageData(currentPath, pageDataList) || findPageData('인증 토큰 발급', pageDataList);
  
  // userInfo가 로딩 중일 때는 검증을 지연시킴
  const shouldValidateAccess = authCtx.isLoggedIn && authCtx.userInfo.m_no && getShouldValidateAccess(pageDataRaw.data[0], authCtx);

  // isLoggedIn = true 이고 userInfo가 아직 로딩 중일 때는 검증하지 않기 위해 userInfo.m_no = undefined 값으로 전달
  useValidatePageAccess(shouldValidateAccess);

  // 페이지가 변경되면 API 테스트 섹션에서 데이터 리셋
  useEffect(() => {
    setParams(newParams);
  }, [authCtx, newParams, pageDataRaw, navigate]);

  // userInfo가 로딩 중일 때 처리
  if (authCtx.isLoggedIn && !authCtx.userInfo.m_no) {
    return <LoadingPage message='사용자 정보를 불러오는 중...'></LoadingPage>;
  }

  // m_no에 따라 사이드 네비게이션 바에 노출되는 항목들 필터링
  const filteredPageDataList = getFilteredPageDataList(authCtx, pageDataList);
  const pageDataRawFiltered = getPageDataRawFiltered(pageDataRaw, authCtx);

  return (
    (newParams === params) ? <DescriptionPageTemplate pageDataRaw={pageDataRawFiltered} filteredPageDataList={filteredPageDataList} /> : ''
  );
};

export default DetailLoadingPage;